<template>
    <div id="left-bar-scanning">
        <ul>
            <li class="menu-title text-center">
                <i class="fa fa-file-pdf"></i>
                {{ $t("LeftBarScanning.scanning") }}
            </li>
            <li class="has_sub active">
                <router-link to="/scanning/dashboard" class="waves-effect active">
                    <i class="fa fa-chart-line"></i>
                    <span> {{ $t("LeftBarScanning.dashboard") }} </span>
                </router-link>
            </li>
        </ul>
        <div class="clearfix"></div>
    </div>
</template>

<script>
export default {
    name: "LeftBarScanning",
};
</script>

<style lang="scss">
    @import "../../../assets/scss/colors";

    #left-bar-scanning {
        .waves-effect {
            &.active {
                border-left-color: $scanning-color;
                i {
                    color: $scanning-color;
                }
            }
            .waves-ripple {
                background-color: rgba($scanning-color, 0.45) !important;
            }
        }
    }
</style>